// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EoatG","placeholdersHeader":"styles_placeholdersHeader__2xD82","editorStyle":"styles_editorStyle__2GOwu","placeholdersBox":"styles_placeholdersBox__2uwrH"};